'use strict';

namespace Core {
    class BookingFormHeader {
        private tripHeading = '';

        constructor(tripService, $routeParams, basketStore, $q, resourceService) {
            tripService.getTrip($routeParams.tripId)
                .then(trip => {
                    let promise = $q.when();
                    let resource = '';
                    switch (trip.TripType) {
                        case tripService.tripTypes.Holiday:
                            resource = resourceService.get('YOURHOLIDAYTO');
                            promise = basketStore.hotel(trip.BasketId);
                            break;
                        case tripService.tripTypes.Hotel:
                            resource = resourceService.get('YOURHOTELIN');
                            promise = basketStore.hotel(trip.BasketId);
                            break;
                        case tripService.tripTypes.Flight:
                            resource = resourceService.get('YOURFLIGHTTO');
                            promise = basketStore.flight(trip.BasketId);
                            break;
                        case tripService.tripTypes.Transfer:
                            resource = resourceService.get('YOURTRANSFERTO');
                            promise = basketStore.transfer(trip.BasketId);
                            break;
                        case tripService.tripTypes.Parking:
                            resource = resourceService.get('YOURAIRPORTPARKINGAT');
                            break;
                        case tripService.tripTypes.Attractions:
                            resource = resourceService.get('YOURATTRACTIONS');
                            break;
                        case tripService.tripTypes.Insurance:
                            resource = resourceService.get('YOURTRAVELINSURANCE');
                            break;
                        case tripService.tripTypes.Marhaba:
                            resource = resourceService.get('YOURMARHABA');
                            break;
                    }

                    promise.then((result) => {
                        if (result) {
                            const detail = () => {
                                let prop = 'Details.Location';
                                switch (trip.TripType) {
                                    case tripService.tripTypes.Flight:
                                        prop = 'Details.Itinerary.Legs[0].ArrivalAirport.Title';
                                        break;
                                    case tripService.tripTypes.Transfer:
                                        prop = 'Details.Itinerary.OutboundLeg.DestinationPoint';
                                        break;
                                    case tripService.tripTypes.Attractions:
                                        prop = 'LineItems[0].Description.Title';
                                        break;
                                }
                                return prop;
                            };
                            let destination = result ? _.get(result, detail(), '') : '';

                            if(!destination) {
                                if(trip.TripType === tripService.tripTypes.Transfer){
                                    destination = _.get(result, 'Details.Itinerary.InboundLeg.DestinationPoint', '');
                                }
                            }

                            this.tripHeading = String.format(resource, destination);
                        } else if (trip.TripType === tripService.tripTypes.Parking) {
                            this.tripHeading = String.format(resource,
                                _.get(trip, 'ParkingRequest.Airport.ShortTitle', ''));
                        } else {
                            this.tripHeading = resource;
                        }
                    });
                });

        }

    }

    angular
        .module('core')
        .directive('bookingFormHeader', (tripService, $routeParams, basketStore, resourceService) => {
            return {
                restrict: 'E',
                template: `<div class="sc-o-row u-grid-gutter-y">
                            <div class="sc-o-col-m-8 sc-o-col-l-6">
                                <h1 class="sc-o-hero-heading sc-o-hero-heading--s">
                                    {{ bfh.tripHeading }}
                                </h1>
                            </div>
                        </div>`,
                controller: BookingFormHeader,
                controllerAs: 'bfh'
            };
        });
}
